import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { mixinRobotoBold, mixinRobotoRegular } from '../../../../styles';

export const RFQSelectorStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }

  h3 {
    font-size: 16px;
    color: var(--nest-level-tab-font);
  }

  .link-rfq-wrapper {
    display: flex;
    flex-direction: column;
    height: calc(100% - 56px);
  }

  .link-rfq-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
  }

  .link-rfq-header .button-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .rfq-grid {
    flex: 1;
  }

  .grid-styles {
    width: 100%;
    height: 100%;
  }

  .actions {
    padding: 1rem;
    display: grid;
  }

  .actions zero-button::part(control) {
    justify-content: center;
  }

  .vppa-info {
    display: flex;
    font-size: 12px;
    color: var(--gray-lighter);
    border-top: 1px solid var(--border-1);
    border-bottom: 1px solid var(--gray-lighter);
    height: 32px;
    align-items: center;
    padding: 0 15px;
    ${mixinRobotoRegular}
  }

  .vppa-info > div {
    width: 25%;
  }

  .rfq-selection-desciption {
    font-size: 13px;
    padding: 0 15px;
    color: var(--nest-level-tab-font);
    ${mixinRobotoRegular}
  }

  .rfq-header {
    font-size: 12px;
    line-height: 32px;
    padding: 15px 15px 0;
    ${mixinRobotoBold}
  }

  :host(.button-text)::part(control) {
    justify-content: center !important;
  }
`;
